{
  "SelectOptionEmpty": {
    "noResults": "未找到结果"
  },
  "UnitField": {
    "cm_long": "公制 (厘米)",
    "cm": "厘米",
    "in_long": "英制 (英寸)",
    "in": "英寸",
    "m_long": "公制 (米)",
    "m": "米",
    "ft_long": "英制 (英尺)",
    "ft": "英尺",
    "placeholders": {
      "feet": "英尺",
      "inches": "英寸",
      "amount": "金额",
      "unit": "单位"
    }
  }
}
